var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "md:ml-8 flex-1" }, [
    _c(
      "div",
      { staticClass: "p-2 sm:p-6 bg-white rounded-lg" },
      [
        _c("SectionHeader", {
          attrs: {
            title: "Documentation Requirements",
            currentUser: _vm.currentUser,
          },
          on: {
            edit: function ($event) {
              return _vm.$emit("edit")
            },
          },
        }),
        _c("hr", { staticClass: "border-t border-gray-100 mb-4" }),
        _c(
          "InfoSection",
          [
            _c("InfoField", {
              attrs: {
                label: "Progress Notes",
                value: _vm.data.doc_incident_reports,
              },
            }),
            _c("InfoField", {
              attrs: {
                label: "Incident Reports",
                value: _vm.data.doc_incident_reports,
              },
            }),
            _c("InfoField", { attrs: { label: "Care Plan Review" } }, [
              _c("p", { staticClass: "text-gray-600" }, [
                _vm._v(
                  " Changes Noted: " +
                    _vm._s(_vm.data.review_changes_notes || "N/A")
                ),
                _c("br"),
                _vm._v(
                  " New Goals: " +
                    _vm._s(_vm.data.review_new_goals || "N/A") +
                    " "
                ),
                _c("br"),
                _vm._v(
                  " General Notes: " +
                    _vm._s(_vm.data.review_general_notes || "N/A") +
                    " "
                ),
              ]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }